import { getCurrentBranchName } from 'app/branches/selectors';
import { getCurrentProjectId } from 'app/project/selectors';
import { useSelector } from 'react-redux';
import { type LinkHookProps, useLink } from '../link/link-hook';

export type SimpleLinkHookProps = Omit<LinkHookProps, 'projectId' | 'branchName'> & {
  fullWidth?: boolean;
};

export const useSimpleLink = (props: SimpleLinkHookProps) => {
  const projectId = useSelector(getCurrentProjectId);
  const branchName = useSelector(getCurrentBranchName);
  const linkProps = useLink({ projectId, branchName, ...props });
  return {
    ...linkProps,
    fullWidth: props.fullWidth
  };
};
